import React from 'react';

const Projects = () => {
  return (
    <div className="projects" id="projects">
      <h3 className="sub-title text text-EN">Projects</h3>
      <h3 className="sub-title text text-UA">Проєкти</h3>

      <ol className="project-items-block">
        <li>
          <a href="https://store.steampowered.com/app/2458310/New_Arc_Line/">
            New Arc Line
          </a>
        </li>
        <li>
          <a href="https://worldofwarplanes.com/">World of Warplanes</a>
        </li>
      </ol>
    </div>
  );
};

export default Projects;
